import styled from 'styled-components';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import WarningIcon from 'components/Permissions/WarningIcon';
import Slider from 'components/Toggle/Slider';

const Row = styled.div`
  margin: 0 -10px;
  padding: 0 15px;
  ${({ theme, hideBottomBorder }) => `
    border-bottom: ${
      hideBottomBorder ? 'none' : `1px solid ${theme.borderColor}`
    };
    &:first-of-type {
      border-top: 1px solid ${theme.borderColor};
    }
  `}
`;

const Title = styled.div`
  color: black;
  flex-grow: 1;
  font-size: 18px;
  line-height: 44px;
  ${({ bold, theme }) => bold && `font-family: ${theme.fontBold}`};
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ToggleContainer = styled.div`
  margin-top: 9px;
`;

export default class SliderItem extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    item: PropTypes.shape({
      isNew: PropTypes.bool,
      value: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    }),
    onChange: PropTypes.func.isRequired
  };

  onClick = () =>
    this.props.onChange(this.props.item.value, !this.props.checked);

  render() {
    const {
      checked,
      hideBottomBorder,
      item: { isNew, showWarning, title }
    } = this.props;
    return (
      <Row onClick={this.onClick} hideBottomBorder={hideBottomBorder}>
        <TitleRow>
          <Title bold={isNew}>
            {title}
            {showWarning && <WarningIcon />}
          </Title>
          <ToggleContainer>
            <Slider checked={checked} />
          </ToggleContainer>
        </TitleRow>
      </Row>
    );
  }
}
